import { render, staticRenderFns } from "./StakePulseDogecoin.vue?vue&type=template&id=cdab7aa6&"
import script from "./StakePulseDogecoin.vue?vue&type=script&lang=js&"
export * from "./StakePulseDogecoin.vue?vue&type=script&lang=js&"
import style0 from "./StakePulseDogecoin.vue?vue&type=style&index=0&id=cdab7aa6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports